export function addGlowEffect() {
  const buttons = document.querySelectorAll(".vote-btn");

  buttons.forEach((btn) => {
    // Inicial glow: color aleatorio
    let currentColor = getRandomColor();
    btn.style.boxShadow = `0 0 10px ${currentColor}, 0 0 20px ${currentColor}`;
    btn.style.transition = "box-shadow 0.5s ease";

    // Animar glow aleatorio
    const interval = setInterval(() => {
      currentColor = getRandomColor();
      btn.style.boxShadow = `0 0 10px ${currentColor}, 0 0 20px ${currentColor}`;
    }, 1500);

    // Guardar referencia para limpiar después
    btn.dataset.glowInterval = interval;

    // Cuando se vote (botón deshabilitado), sigue el glow individual
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === "disabled" && btn.disabled) {
          clearInterval(interval); // detener animación anterior
          const fixedGlow = getRandomColor(); // un color aleatorio fijo
          btn.style.boxShadow = `0 0 15px ${fixedGlow}, 0 0 25px ${fixedGlow}`;
        }
      });
    });

    observer.observe(btn, { attributes: true });
  });
}

// Generar color aleatorio
function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
